import { render, staticRenderFns } from "./StockArchives.vue?vue&type=template&id=3d40d558&scoped=true&"
import script from "./StockArchives.vue?vue&type=script&lang=ts&"
export * from "./StockArchives.vue?vue&type=script&lang=ts&"
import style0 from "./StockArchives.vue?vue&type=style&index=0&id=3d40d558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40d558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
